import { Edit as EditInterface } from '../../../../interfaces/reservation.interface';
import { Validation } from '../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, Regex } from '../../../../utils/appConstant';

export const validateEditForm = (formData: EditInterface, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.checkInDate) {
    if (!formData.checkInDate) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.checkInDate,
        message: APP_ERROR_MESSAGES.reservations.edit.blankCheckInDate,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.checkOutDate) {
    if (!formData.checkOutDate) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.checkOutDate,
        message: APP_ERROR_MESSAGES.reservations.edit.blankCheckOutDate,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.xNightRoomFees) {
    if (!formData.xNightRoomFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.xNightRoomFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidXNightRoomFees,
      });
    } else if (!Regex.floatValues.test(formData.xNightRoomFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.xNightRoomFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidXNightRoomFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.perNightFees) {
    if (!formData.perNightFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.perNightFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidPerNightFees,
      });
    } else if (!Regex.floatValues.test(formData.perNightFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.perNightFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidPerNightFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.cleaningFees) {
    if (!formData.cleaningFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.cleaningFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidCleaningFees,
      });
    } else if (!Regex.floatValues.test(formData.cleaningFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.cleaningFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidCleaningFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.linenFees) {
    if (!formData.linenFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.linenFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidLinenFees,
      });
    } else if (!Regex.floatValues.test(formData.linenFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.linenFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidLinenFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.petFees) {
    if (!formData.petFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.petFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidPetFees,
      });
    } else if (!Regex.floatValues.test(formData.petFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.petFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidPetFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.hostFees) {
    if (!formData.hostFees) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.hostFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidHostFees,
      });
    } else if (!Regex.floatValues.test(formData.hostFees.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.hostFees,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidHostFees,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.discount) {
    if (!formData.discount) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.discount,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidDiscount,
      });
    } else if (!Regex.floatValues.test(formData.discount.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.discount,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidDiscount,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.matTax) {
    if (!formData.matTax) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.matTax,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidMatTax,
      });
    } else if (!Regex.floatValues.test(formData.matTax.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.matTax,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidMatTax,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.hstTax) {
    if (!formData.hstTax) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.hstTax,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidHstTax,
      });
    } else if (!Regex.floatValues.test(formData.hstTax.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.hstTax,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidHstTax,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.adjustments) {
    if (!formData.adjustments) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.adjustments,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidAdjustments,
      });
    } else if (!Regex.floatWithNegative.test(formData.adjustments.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.adjustments,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidAdjustments,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.hostPayout) {
    if (formData.hostPayout) {
      if (!Regex.floatValues.test(formData.hostPayout.trim())) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.hostPayout,
          message: APP_ERROR_MESSAGES.reservations.edit.invalidHostPayout,
        });
      }
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.actualRevenue) {
    if (formData.actualRevenue && !Regex.floatValues.test(formData.actualRevenue.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.actualRevenue,
        message: APP_ERROR_MESSAGES.reservations.edit.invalidActualRevenue,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewedBy) {
    const reviewed = formData.reviewed;
    if (!reviewed && !formData.reviewedBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.reviewedBy,
        message: APP_ERROR_MESSAGES.reservations.edit.blankReviewedBy
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
    if (!formData.reviewed && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.reservations.edit.blankNotes
      });
    }
  }

  return validations;
};
